<template>
  <div>
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle title="发布信息" hideSearch="true" :showCart="false" />
      <div class="box">
        <div class="tabsBox">
          <el-tabs type="border-card">
            <el-tab-pane label="发布求购信息">
              <PublishDemand></PublishDemand>
            </el-tab-pane>
            <el-tab-pane label="发布供应信息">
              <PublishSupply></PublishSupply>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import PublishSupply from "@/components/SellCenter/components/PublishSupply";
import PublishDemand from "@/components/SellCenter/components/PublishDemand";
import { mapState } from "vuex";

export default {
  name: "publishMessage",
  data() {
    return {};
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.$checkLogin(this.userInfo).catch(() => {
      this.$confirm("发布信息请先登录, 是否前往登录页?", "提示", {
        confirmButtonText: "去登录",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.$router.push("/login");
        })
        .catch(() => {});
    });
  },
  components: {
    PageSearchTitle,
    PublishSupply,
    PublishDemand,
  },
  methods: {},
};
</script>

<style scoped lang='less'>
@media screen and(min-width:320px) and(max-width:1200px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 150px 0;
}
.box {
  margin-top: 20px;
  min-height: 300px;
}
.tabsBox {
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/PublishMessage.vue